/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from 'react';
import Plot from 'react-plotly.js';

const CategorySnapshot = ({ data }) => {

  // SORT HIGHEST RETURN FIRST
  const sortedData = [...data].sort(
    (a, b) => b.avg_return - a.avg_return
  );
  return (

    <div className="bg-white rounded-3xl p-8 shadow-sm border">

      {/* HEADER */}
      <div className="mb-8">

        <h3 className="text-3xl font-bold text-gray-900 mb-2">
          Category Performance Snapshot
        </h3>

        <p className="text-gray-500">
          Average 3-Year category performance across mutual fund segments.
        </p>

      </div>


      {/* CHART */}
      {/*<div className="w-full">*/}
      <div className="w-full bg-gray-100 flex items-end gap-2 p-4 rounded-xl">

        <Plot

          data={[
            {
              x: sortedData.map(item => item.category),

              y: sortedData.map(item => item.avg_return),

              type: 'bar',

              text: sortedData.map(
                // item => `${item.avg_return?.toFixed(1)}%`
                item => `${Number(item.avg_return).toFixed(2)}%`

              ),

              textposition: 'outside',

              hovertemplate:
                '<b>%{x}</b><br>' +
                'Avg Return: %{y:.2f}%<br>' +
                'Funds: %{customdata}<br>' +
                '<extra></extra>',
                  customdata: sortedData.map(
                  item => item.fund_count
            )
            }
          ]}

          layout={{

            height: 400,

            margin: {
              l: 60,
              r: 30,
              t: 20,
              b: 60
            },

            paper_bgcolor: 'white',

            plot_bgcolor: 'white',

            xaxis: {
              title: '',
              tickangle: -35,
              automargin: true
            },

            yaxis: {
              title: 'Average 3Y Return (%)',
              gridcolor: '#e5e7eb',
              zeroline: false
            },

            showlegend: false,

            font: {
              family: 'Inter, sans-serif'
            }

          }}

          config={{
            responsive: true,
            displayModeBar: false
          }}

          style={{
            width: '100%'
          }}

        />

      </div>


      {/* FOOTER INSIGHT */}
      <div className="mt-6 text-sm text-gray-500">

        Categories are ranked by average 3-year annualized returns.

      </div>

    </div>
  );
};

export default CategorySnapshot;